(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const submitCart=control=>{const form=control.closest('form');const updateButton=form?.querySelector('button[name="update"]');if(form&&updateButton)form.requestSubmit(updateButton)};
  const syncDecreaseIcon=control=>{const input=control.querySelector('input[name="updates[]"]');const decrease=control.querySelector('[data-cart-quantity-decrease]');const isRemove=Number(input.value)<=1;decrease.querySelector('[data-cart-minus]').hidden=isRemove;decrease.querySelector('[data-cart-trash]').hidden=!isRemove;decrease.setAttribute('aria-label',isRemove?decrease.dataset.removeLabel:decrease.dataset.decreaseLabel)};
  document.querySelectorAll('.maison-velora-cart-quantity').forEach(syncDecreaseIcon);
  document.addEventListener('click',event=>{const button=event.target.closest('[data-cart-quantity-decrease],[data-cart-quantity-increase]');if(!button)return;const control=button.closest('.maison-velora-cart-quantity');const input=control.querySelector('input[name="updates[]"]');const minimum=Number(input.min)||0;const maximum=Number(input.max)||Infinity;const step=Number(input.step)||1;const direction=button.hasAttribute('data-cart-quantity-increase')?1:-1;const current=Number(input.value)||0;input.value=String(Math.min(maximum,Math.max(minimum,current+direction*step)));syncDecreaseIcon(control);submitCart(control)});
  document.addEventListener('change',event=>{const input=event.target.closest('.maison-velora-cart-quantity input[name="updates[]"]');if(!input)return;const control=input.closest('.maison-velora-cart-quantity');input.value=String(Math.max(0,Number(input.value)||0));syncDecreaseIcon(control);submitCart(control)});
  document.addEventListener('click',async event=>{const button=event.target.closest('.maison-velora-buyer-protection__toggle');if(!button)return;const protection=button.closest('[data-buyer-protection]');const isActive=protection.classList.contains('is-active');const error=protection.querySelector('[data-protection-error]');button.disabled=true;error.hidden=true;try{const endpoint=isActive?'cart/change.js':'cart/add.js';const payload=isActive?{id:protection.dataset.lineKey,quantity:0}:{items:[{id:Number(protection.dataset.variantId),quantity:1}]};const response=await fetch(window.Shopify.routes.root+endpoint,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});if(!response.ok)throw new Error('Cart update failed');window.location.reload()}catch(cartError){error.hidden=false;button.disabled=false}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];const thumbnails=[...gallery.querySelectorAll('[data-gallery-thumbnail]')];const current=gallery.querySelector('[data-gallery-current]');let active=Math.max(0,slides.findIndex(slide=>!slide.hidden));const show=index=>{if(!slides.length)return;active=(index+slides.length)%slides.length;slides.forEach((slide,slideIndex)=>{slide.hidden=slideIndex!==active});thumbnails.forEach((thumbnail,thumbnailIndex)=>{thumbnail.setAttribute('aria-current',thumbnailIndex===active?'true':'false')});if(current)current.textContent=String(active+1);thumbnails[active]?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'})};gallery.showMedia=mediaId=>{const index=slides.findIndex(slide=>slide.dataset.mediaId===String(mediaId));if(index>=0)show(index)};gallery.querySelector('[data-gallery-previous]')?.addEventListener('click',()=>show(active-1));gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(active+1));thumbnails.forEach((thumbnail,index)=>thumbnail.addEventListener('click',()=>show(index)));show(active)});
  document.addEventListener('change',event=>{const radio=event.target.closest('[data-variant-radio]');if(!radio)return;const section=radio.closest('[data-product-section]');const info=radio.closest('.maison-velora-product-info');const price=info.querySelector('[data-current-price]');const button=info.querySelector('[data-add-button]');price.textContent=radio.dataset.price;button.disabled=radio.dataset.available!=='true';button.textContent=button.disabled?button.dataset.unavailableLabel:button.dataset.availableLabel;if(radio.dataset.mediaId)section.querySelector('[data-product-gallery]')?.showMedia(radio.dataset.mediaId);const url=new URL(window.location.href);url.searchParams.set('variant',radio.value);window.history.replaceState({},'',url)});
  document.querySelectorAll('.maison-velora-delivery-estimate').forEach((estimate)=>{const start=new Date();const end=new Date();start.setDate(start.getDate()+6);end.setDate(end.getDate()+13);const locale=document.documentElement.lang||'fr-FR';const formatter=new Intl.DateTimeFormat(locale,{day:'numeric',month:'long'});estimate.querySelector('[data-delivery-start]').textContent=formatter.format(start);estimate.querySelector('[data-delivery-end]').textContent=formatter.format(end)});
  document.addEventListener('click',event=>{const button=event.target.closest('[data-quantity-decrease],[data-quantity-increase]');if(!button)return;const control=button.closest('.maison-velora-quantity-control');const input=control.querySelector('input[name="quantity"]');const minimum=Number(input.min)||1;const maximum=Number(input.max)||Infinity;const step=Number(input.step)||1;const direction=button.hasAttribute('data-quantity-increase')?1:-1;const current=Number(input.value)||minimum;input.value=String(Math.min(maximum,Math.max(minimum,current+direction*step)));input.dispatchEvent(new Event('change',{bubbles:true}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opening-soon-poster"] && !Shopify.designMode) return;
  try {
    
  const initializeOpeningPoster = (root) => {
    const section = root.matches?.('[data-opening-poster]') ? root : root.querySelector?.('[data-opening-poster]');
    if (!section || section.dataset.openingPosterReady === 'true') return;

    const button = section.querySelector('[data-opening-toggle]');
    const panel = section.querySelector('[data-opening-panel]');
    const openLabel = section.querySelector('[data-opening-label-open]');
    const closeLabel = section.querySelector('[data-opening-label-close]');
    if (!button || !panel) return;

    const setOpen = (open) => {
      section.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', String(open));
      panel.setAttribute('aria-hidden', String(!open));
      panel.toggleAttribute('inert', !open);
      if (openLabel) openLabel.hidden = open;
      if (closeLabel) closeLabel.hidden = !open;
    };

    button.addEventListener('click', () => setOpen(button.getAttribute('aria-expanded') !== 'true'));
    section.dataset.openingPosterReady = 'true';

    if (window.location.hash === '#ouverture-prochaine') setOpen(true);
  };

  document.querySelectorAll('[data-opening-poster]').forEach(initializeOpeningPoster);
  document.addEventListener('shopify:section:load', (event) => initializeOpeningPoster(event.target));
  window.addEventListener('hashchange', () => {
    if (window.location.hash !== '#ouverture-prochaine') return;
    const section = document.getElementById('ouverture-prochaine');
    if (!section) return;
    const button = section.querySelector('[data-opening-toggle]');
    if (button?.getAttribute('aria-expanded') !== 'true') button?.click();
    requestAnimationFrame(() => section.scrollIntoView({ block: 'start' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-recommendations]').forEach(container=>{if(container.dataset.loaded==='true')return;container.dataset.loaded='true';fetch(container.dataset.url).then(response=>response.text()).then(text=>{const html=new DOMParser().parseFromString(text,'text/html');const incoming=html.querySelector('[data-product-recommendations]');if(incoming?.innerHTML.trim())container.innerHTML=incoming.innerHTML}).catch(()=>{})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["withdrawal-form"]) return;
  try {
    
  document.querySelectorAll('.maison-velora-withdrawal__form').forEach((form) => {
    const storageKey = 'maison-velora-withdrawal-request';
    form.addEventListener('submit', () => {
      const timestamp = form.querySelector('[data-withdrawal-timestamp]');
      const submittedAt = new Date().toISOString();
      if (timestamp) timestamp.value = submittedAt;

      const data = new FormData(form);
      const request = {
        email: data.get('contact[email]'),
        firstName: data.get('contact[first_name]'),
        lastName: data.get('contact[last_name]'),
        orderNumber: data.get('contact[order_number]'),
        products: data.get('contact[products]'),
        quantity: data.get('contact[quantity]'),
        receivedAt: data.get('contact[received_at]'),
        reason: data.get('contact[reason]'),
        submittedAt,
        eventSent: false
      };
      sessionStorage.setItem(storageKey, JSON.stringify(request));
    });

    const success = form.querySelector('[data-withdrawal-success]');
    if (!success) return;

    try {
      const request = JSON.parse(sessionStorage.getItem(storageKey));
      if (!request || !request.email || request.eventSent) return;

      window._learnq = window._learnq || [];
      window._learnq.push(['identify', {
        '$email': request.email,
        '$first_name': request.firstName,
        '$last_name': request.lastName
      }]);
      window._learnq.push(['track', 'Withdrawal Request Submitted', {
        'Order Number': request.orderNumber,
        'Products': request.products,
        'Quantity': request.quantity,
        'Received At': request.receivedAt,
        'Reason': request.reason,
        'Submitted At': request.submittedAt
      }]);
      request.eventSent = true;
      sessionStorage.setItem(storageKey, JSON.stringify(request));
    } catch (error) {
      return;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
